var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMorocco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_27530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_27530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "#B01F35"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_27530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_27530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0837 8.77637L11.7637 8.7804L16.6807 12.5344L17.4187 11.9724L14.4347 9.69037L15.7997 9.68738L16.0837 8.77637Z",
    fill: "#296437"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_27530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_27530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.755 8.77704L17.417 4.45703L15.54 10.535L16.277 11.0981L17.417 7.41406L17.842 8.77704H18.755Z",
    fill: "#296437"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_27530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_27530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5799 11.4484L23.0759 8.77637H16.9939L16.7129 9.68738H20.3979L19.2989 10.5344L19.5799 11.4484Z",
    fill: "#296437"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_27530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_27530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4189 13.1015L20.9139 15.7655L19.0359 9.6875H18.1239L19.2629 13.3745L18.1569 12.5345L17.4189 13.1015Z",
    fill: "#296437"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_27530",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1977 0.550781H0.638672V20.1328H34.1977V0.550781Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_27530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2558 11.4446L13.9238 15.7686L18.8398 12.0117L18.5588 11.0977L15.5768 13.3787L15.9958 12.0156L15.2558 11.4446Z",
    fill: "#296437"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorocco);
export default __webpack_public_path__ + "static/media/MOROCCO.879150f943e6f22a2ad5feec6a6a7b3d.svg";
export { ForwardRef as ReactComponent };